module.exports = __webpack_public_path__ + "static/media/cloud-b-v3.f0bd6990.svg";